import { flexRender, type Header } from '@tanstack/react-table';

import { TableCell } from '@/components/Table';
import { cn } from '@/lib/utils';

import {
  getColumnTextAlignmentClassName,
  getPinnedCellClassName,
  getPinnedCellStyles,
  type PinnedOffsets,
} from './dataTableCellStyles';
import { type DataTableSize } from './types';

type DataTableTableFooterCellProps<TData extends object> = {
  header: Header<TData, unknown>;
  canScrollLeft: boolean;
  canScrollRight: boolean;
  sortedColumnId?: string;
  pinnedOffsets: PinnedOffsets;
  size?: DataTableSize;
};

const DataTableTableFooterCell = <TData extends object>({
  header,
  canScrollLeft,
  canScrollRight,
  sortedColumnId,
  pinnedOffsets,
  size = 'large',
}: DataTableTableFooterCellProps<TData>) => {
  const isSortedColumn = sortedColumnId === header.column.id;

  return (
    <TableCell
      colSpan={header.colSpan}
      className={cn(
        'font-semibold text-gray-900',
        size === 'small' ? 'h-8 px-2 py-1' : 'h-9',
        getColumnTextAlignmentClassName(header.column),
        isSortedColumn && 'bg-gray-100',
        getPinnedCellClassName(header.column, 'footer', canScrollLeft, canScrollRight),
      )}
      style={getPinnedCellStyles(header.column, pinnedOffsets)}
    >
      {header.isPlaceholder
        ? null
        : flexRender(header.column.columnDef.footer, header.getContext())}
    </TableCell>
  );
};

export default DataTableTableFooterCell;
